import { render, staticRenderFns } from "./WebServiceCredentialDetailsTB.vue?vue&type=template&id=61b017ca&"
import script from "./WebServiceCredentialDetailsTB.vue?vue&type=script&lang=js&"
export * from "./WebServiceCredentialDetailsTB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b017ca')) {
      api.createRecord('61b017ca', component.options)
    } else {
      api.reload('61b017ca', component.options)
    }
    module.hot.accept("./WebServiceCredentialDetailsTB.vue?vue&type=template&id=61b017ca&", function () {
      api.rerender('61b017ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/WebServiceCredentialDetailsTB.vue"
export default component.exports